class AuthenticationBackend {}
export default AuthenticationBackend;
